import React from "react";

const ArticleDescription = ({ description }: { description: string }) => {
  if (!description) return null;

  return <p className="article-description">{description}</p>;
};

export default ArticleDescription;
